import React, { useEffect } from 'react';
import { VStack } from 'native-base';
import {
    useGetMilestones,
    useSpringBigStore,
    useI18n,
} from '@springbig/shared';
import CardMilestone from './components/CardMilestone';
import { useAuthorization } from '~/hooks/auth';
import SuspendedMerchantScreen from '~/shared/SuspendedMerchantScreen';
import { NoDataPlaceholder } from '~/shared/NoDataPlaceholder';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { Section } from '~/shared/Theme';
import { DarkSkeleton } from '~/shared/DarkSkeleton';

const MilestoneScreen = () => {

    const { isLoadingAuth } = useAuthorization();
    const { walletId, member } = useSpringBigStore();

    const {
        refetch,
        data,
        isLoading
    } = useGetMilestones();
    const { t } = useI18n();

    useEffect(() => {

        if (walletId) {
            refetch();
        }
    }, [walletId]);

    if (isLoading || isLoadingAuth || !member || !walletId) {
        return <MilestoneSkeleton />;
    }

    if (
        !data?.milestones?.spend_milestones?.length &&
        !data?.milestones?.points_milestones?.length &&
        !data?.milestones?.visits_milestones?.length
    ) {
        return (
            <Section>
                <NoDataPlaceholder
                    title={'common.milestones_placeholder_title'}
                    message={'common.milestones_placeholder_subtitle'}
                    callback={refetch}
                    isLoading={isLoading}
                    iconName={faTrophy}
                />
            </Section>
        );
    }

    return (
        <Section>
            { member && member.show_pending_modal &&
                <SuspendedMerchantScreen />
            }
            <VStack space={4} py={4}>
                { data?.milestones?.spend_milestones?.length > 0 && (
                    <>
                        { data.milestones.spend_milestones.map((item, index) => {

                            return (
                                <CardMilestone
                                    key={index}
                                    currentValue={item.value - item.remaining}
                                    milestone={item}
                                    t={t}
                                    type={'spend'}
                                />
                            );
                        })}
                    </>
                )}
                { data?.milestones?.points_milestones?.length > 0 && (
                    <>
                        { data.milestones.points_milestones.map((item, index) => {

                            return (
                                <CardMilestone
                                    key={index}
                                    currentValue={item.value - item.remaining}
                                    milestone={item}
                                    t={t}
                                    type={'points'}
                                />
                            );
                        })}
                    </>
                )}
                { data?.milestones?.visits_milestones?.length > 0 && (
                    <>
                        { data.milestones.visits_milestones.map((item, index) => {

                            return (
                                <CardMilestone
                                    key={index}
                                    currentValue={data.milestones.lifetime_visits}
                                    milestone={item}
                                    t={t}
                                    type={'visits'}
                                />
                            );
                        })}
                    </>
                )}
            </VStack>
        </Section>
    );
};

const MilestoneSkeleton = () => {

    return (

        <Section>
            <VStack space={4} py={4}>
                { Array.from({ length: 3 }).map((_, index) =>

                    <VStack key={index} h={'103px'} backgroundColor={'white'} justifyContent={'space-between'} py={2} px={4}>
                        <DarkSkeleton h={'23px'} w={'80%'} mt={1.5} />
                        <DarkSkeleton h={'24px'} w={'95%'} />
                        <DarkSkeleton h={'18px'} w={'50%'} mb={1.5} />
                    </VStack>
                )}
            </VStack>
        </Section>
    );
};

export default MilestoneScreen;
